<template>
    <withdrawal-dialog :value="true" @input="$emit('close')"
        :lines="mainLines" :facility-name="$store.state.settings.name"
        :person="person" :submit="submit" @withdrawn="$emit('withdrawn')" />
</template>

<script>
import WithdrawalDialog from './WithdrawalDialog.vue';

export default {
    name: 'zoezi-withdrawal-my-page-dialog',

    components: { WithdrawalDialog },

    props: {
        entry: { type: Object, required: true },
    },

    computed: {
        mainLines() {
            return (this.entry.items || []).filter(item => !item.included && item.payment_id);
        },
        person() {
            const user = this.$store.state.user || {};

            return { name: user.name, email: user.mail };
        },
    },

    methods: {
        submit(paymentId, message) {
            return this.$api.post('/api/memberapi/withdrawal/add', { payment_id: paymentId, message });
        },
    },
};
</script>
